exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{overflow:hidden}[data-ng-click],[ng-click],a:focus,input[type=button]:focus,input[type=submit]:focus{outline:none}.translate-cloak{visibility:hidden!important}.gz-padding{padding:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/core/core.scss
// module id = 124
// module chunks = 0